import { applyVueInReact } from 'vuereact-combined';

import SettingsManageUsersInfoAvatar from '@/components/SettingsManageUsersInfoAvatar.vue';

const ReactAppAvatar = applyVueInReact(SettingsManageUsersInfoAvatar);
interface Props {
	user?: Record<string, unknown>;
	size?: number;
	shorten?: boolean;
	initials?: boolean;
	showBorder?: boolean;
	showName?: boolean;
}
const Avatar = (props: Props) => {
	const propsToPass = props ? { ...props } : {};
	return <ReactAppAvatar {...propsToPass} />;
};

export default Avatar;
